import {
  GetCorpOurPeopleDocument,
  GetCorpOurPeopleQuery,
  GetCorpOurPeopleQueryVariables,
  Scalars,
} from 'generated/graphql';
import { client } from './client';
import { getLocalesForGraphQL } from '../utils/helpers';

export async function getCorpOurPeople(id: string, locale: string) {
  return client.query<GetCorpOurPeopleQuery, GetCorpOurPeopleQueryVariables>({
    query: GetCorpOurPeopleDocument,
    variables: {
      locales: getLocalesForGraphQL(locale),
      where: {
        id,
      },
    },
  });
}
